import React from 'react'

function MoreAftercare() {

 const careTips = [
  {
   title: "use soap.",
   content: "always use a mild, fragrance-free soap or a specially formulated tattoo cleanser to clean the area.",
   content2: "",
  },
  {
   title: "use lotion.",
   content: "ensure lotion is free of fragrances, ethyl alcohol, and other additives, such as colored dye, that could dry out your skin.",
   content2: "",
  },
  {
   title: "100% petroleum? NO.",
   content: "it is best to avoid products that are 100% petroleum, like the OG Vaseline, during the initial healing process.",
   content2: "more petroleum the product has, the thicker the product is on the skin. meaning, it will trap out moisture, and prevent much-needed air flow to your new tattoo."
  },
  {
   title: "infections...",
   content: "tattoos that aren't properly cared for can get infected. infected skin will be red, warm and painful. the wound may also leak pus. please contact us and your doctor if this happens.",
   content2: "",
  },
  {
   title: "allergic reactions...",
   content: "if you're sensitive to the ink used, you may develop a red, itchy skin reaction at the site. red dyes are most likely to cause allergic reactions. please contact us and your doctor if this happens.",
   content2: "",
  }
 ]

 return (
  <>
   <section className='my-8'>
    {careTips.map((tip, index) => (
     <div key={index} className='p-4 lg:mx-14 2xl:mx-[14rem]'>
      <h2 className='font-bold text-[1.1rem] text-[#ff4e00]'>{tip.title}</h2>
      <p className='text-[.9rem]'>{tip.content}</p>
      <p className='text-[.9rem]'>{tip.content2}</p>
     </div>
    ))}


   </section>
  </>
 )
}

export default MoreAftercare